import { render } from "./DocumentList.vue?vue&type=template&id=f27e8262&scoped=true&ts=true"
import script from "./DocumentList.vue?vue&type=script&lang=ts"
export * from "./DocumentList.vue?vue&type=script&lang=ts"

import "./DocumentList.vue?vue&type=style&index=0&id=f27e8262&lang=scss&scoped=true"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f27e8262"]])

export default __exports__